import {Pipe, PipeTransform} from '@angular/core';
import {map, startWith, switchMap} from "rxjs/operators";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {GlobalVariablesService} from "../service/global-variables.service";

@Pipe({
    name: 'sensorDataIcon$',
    standalone: true
})
export class SensorDataIconPipe implements PipeTransform {

    constructor(private translateService: TranslateService,
                private globalVariableService: GlobalVariablesService) {

    }

    transform(values: any | undefined): Observable<{ svgIcon?: string, materialIcon?: string } | undefined> {
        let key:string, value:string
        if (values) {
            key = values.type
            value = values.value
        }
        return this.translateService.onLangChange.pipe(
            startWith({lang: this.translateService.currentLang, translations: this.translateService.translations}),
            map((lang: LangChangeEvent) => {
                return lang.lang + '-' + lang.lang.toUpperCase();//il formato dell ora viene  preso dalla lingua impostata
            }),
            switchMap(lang => {
                return this.globalVariableService.sensorDataType$.pipe(
                    map(sensorDataType => {
                        return {lang, sensorDataType}
                    })
                )
            }),
            map(({lang, sensorDataType}) => {
                return this.globalVariableService.getSensorDataTypeIcon(sensorDataType, value, key);
            })
        );
    }


}
